import React, { useEffect, useState } from "react";
import axios from "axios";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { url } from "../constants/url";
import { useNavigate } from "react-router-dom";

export default function Support() {
  const [expandedItems, setExpandedItems] = useState([]);
  const [requests, setRequests] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const toggleItem = (idx) => {
    setExpandedItems((prev) =>
      prev.includes(idx) ? prev.filter((i) => i !== idx) : [...prev, idx]
    );
  };

  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    axios
      .get(`${url}/api/admin/support-requests`, {
        headers: {
          Authorization: token ? `Bearer ${token}` : undefined
        }
      })
      .then((res) => {
        setRequests(res.data.supportRequests || []);
      })
      .catch((err) => {
        if (err.response?.status === 401) {
          localStorage.clear();
          navigate("/login");
        } else {
          console.error("Error loading support requests:", err);
          setError("Failed to load support requests. Please try again later.");
        }
      })
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <div className="max-w-3xl mx-auto bg-white p-6 rounded-lg shadow-sm">
        {Array(3)
          .fill()
          .map((_, idx) => (
            <div key={idx} className="border-b pb-4 mb-4">
              <Skeleton height={20} width={200} className="mb-2" />
              <Skeleton height={15} width={120} className="mb-2" />
              <Skeleton count={2} />
            </div>
          ))}
      </div>
    );
  }

  if (error) {
    return (
      <div className="max-w-3xl mx-auto bg-white p-6 rounded-lg shadow-sm">
        <p className="text-red-500 text-center">{error}</p>
      </div>
    );
  }

  return (
    <div className="max-w-3xl mx-auto bg-white p-6 rounded-lg shadow-sm">
      <h1 className="text-2xl font-bold mb-6">Support Requests</h1>
      {requests.map((req, idx) => (
        <div key={req.id} className="border-b pb-4 mb-4">
          <div className="flex justify-between items-center mb-1">
            <h2 className="text-lg font-medium">{req.headline}</h2>
            <span className="text-xs text-gray-500">
              {new Date(req.createdAt).toLocaleDateString()}
            </span>
          </div>
          <p className="text-sm text-gray-600 mb-1">
            <strong>Email:</strong> {req.email}
          </p>
          <p className="text-sm text-gray-700">
            {expandedItems.includes(idx)
              ? req.description
              : `${req.description.slice(0, 150)}…`}
          </p>
          {req.description.length > 150 && (
            <button
              onClick={() => toggleItem(idx)}
              className="text-sm font-medium mt-1 text-blue-600 hover:text-blue-800"
            >
              {expandedItems.includes(idx) ? "Show Less" : "Show More"}
            </button>
          )}
        </div>
      ))}
      {requests.length === 0 && (
        <p className="text-center text-gray-500">No support requests found.</p>
      )}
    </div>
  );
}
